import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LayoutDashboard, Users, HandCoins, BarChart3, ScrollText, Settings, LogOut, ArrowLeft } from "lucide-react";

const NAV = [
  { to:"/admin",           icon:LayoutDashboard, label:"Overview",    end:true  },
  { to:"/admin/members",   icon:Users,           label:"Members",     end:false },
  { to:"/admin/loans",     icon:HandCoins,       label:"Loans",       end:false },
  { to:"/admin/withdrawals",icon:HandCoins,      label:"Withdrawals", end:false },
  { to:"/admin/contribution",icon:HandCoins,      label:"Contributions", end:false },
  { to:"/admin/reports",   icon:BarChart3,       label:"Reports",     end:false },
  { to:"/admin/activity",  icon:ScrollText,      label:"Activity Log",end:false },
  { to:"/admin/settings",  icon:Settings,        label:"Settings",    end:false },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-slate-50">
      {/* Dark sidebar */}
      <aside className="hidden md:flex w-56 flex-col bg-slate-900 flex-shrink-0">
        <div className="p-5 border-b border-slate-700">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-9 h-9 rounded-xl bg-emerald-600 flex items-center justify-center text-white text-lg">
              {/* 🌿 */}
              <img src="/heritage.jpg" width="40" height="30" style={{borderRadius:"5px"}} alt="logo" ></img>
            </div>
            <div>
              <p className="font-medium text-white text-sm">Heritage</p>
              <p className="text-slate-400 text-xs">Admin Console</p>
            </div>
          </div>
          <span className="inline-flex items-center gap-1.5 bg-violet-600/20 text-violet-400 text-xs font-medium px-2.5 py-1 rounded-full">
            🛡️ Administrator
          </span>
        </div>
        <nav className="flex-1 p-3 space-y-0.5">
          {NAV.map(({ to, icon:Icon, label, end }) => (
            <NavLink key={to} to={to} end={end}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm transition-colors
                 ${isActive ? "bg-emerald-600/15 text-emerald-400 font-medium" : "text-slate-400 hover:text-slate-200 hover:bg-slate-800"}`}>
              <Icon size={17}/>{label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-700 space-y-1">
          <div className="flex items-center gap-2.5 px-3 py-2">
            <div className="w-8 h-8 rounded-full bg-violet-600 flex items-center justify-center text-white text-xs font-medium flex-shrink-0">
              {user?.first_name?.[0]}{user?.last_name?.[0]}
            </div>
            <div className="min-w-0">
              <p className="text-sm text-white font-medium truncate">{user?.first_name} {user?.last_name}</p>
              <p className="text-xs text-slate-400">Super Admin</p>
            </div>
          </div>
          <button onClick={() => navigate("/")}
            className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-slate-400 hover:text-slate-200 hover:bg-slate-800">
            <ArrowLeft size={17}/> Member view
          </button>
          <button onClick={() => { logout(); navigate("/login"); }}
            className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-red-400 hover:bg-red-900/20">
            <LogOut size={17}/> Sign out
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between">
          <div>
            <h1 className="text-lg font-medium text-slate-800">Admin Console</h1>
            <p className="text-xs text-slate-400 mt-0.5">{new Date().toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric"})}</p>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-slate-500 hidden sm:inline">{user?.email}</span>
            <div className="w-9 h-9 rounded-full bg-violet-600 flex items-center justify-center text-white text-sm font-medium">
              {user?.first_name?.[0]}{user?.last_name?.[0]}
            </div>
          </div>
        </header>
        <main className="flex-1 p-6 overflow-y-auto"><Outlet/></main>
      </div>
    </div>
  );
}
